// @flow
import type {AddressWithoutRegionsType, CurrentAddressType} from 'constants/flow/flowTypesCheckout';

export const defaultState = {
    data: {
        addressId: '0',
        firstName: '',
        lastName: '',
        email: '',
        street: '',
        city: '',
        aptSuiteOther: '',
        zipCode: '',
        phone: '',
        region: '',
        regionId: '',
        regionCode: '',
        country: 'US',
        isDefault: true,
    },
    index: 0,
    editable: false,
    errors: {},
};

/**
 * Set billing address
 * @param {object} state Current state
 * @param {object} action Received action
 * @returns {AddressWithoutRegionsType} Shipping address
 */
export default function currentBillingAddress(
    state: CurrentAddressType = defaultState,
    action: {type: string, [string]: any},
): {data: AddressWithoutRegionsType, index: number} {
    switch (action.type) {
        case 'SET_CURRENT_BILLING_ADDRESS': {
            return {
                data: action.data.address,
                index: action.data.index,
                editable: false,
                errors: {},
            };
        }
        case 'EDIT_CURRENT_BILLING_ADDRESS': {
            return {
                ...state,
                errors: {...state.errors, [action.data.name]: ''},
                data: {...state.data, [action.data.name]: action.data.value},
            };
        }
        case 'CHANGE_CURRENT_BILLING_ADDRESS_MODE': {
            return {
                ...state,
                editable: action.data.editable,
            };
        }
        case 'SET_CURRENT_BILLING_ADDRESS_ERRORS': {
            return {
                ...state,
                errors: action.data.errors,
            };
        }
        case 'FETCH_ADDRESSES_UNAUTHORIZED_CUSTOMER_FULFILLED': {
            return {
                ...state,
                data: action.payload.data.billing,
            };
        }
        default: {
            return state;
        }
    }
}
